export default "__VITE_ASSET__BX8rfeM___"